import gql from 'graphql-tag';

import COULD_NOT_COMPLETE_FRAGMENT from '../serviceDocket/COULD_NOT_COMPLETE_FRAGMENT';

const GET_SERVICE_RUNS_MY_DAY_PREVIEW = gql`
	query getServiceRunsMyDayPreview($filter: ServiceRunPageFilter) {
		getServiceRuns(
			page: 0
			perPage: 50
			sortBy: "planned"
			sortDirection: 1
			filter: $filter
		) {
			items {
				id
				planned
				order
				brief
				briefAcknowledgedAt
				vehicleConfirmed
				machineOrder
				myDayConfirmations {
					key
					at
					items
				}
				myDayPickTopUpStatus {
					canMarkNotNeeded
					markedNotNeeded
					picksUpToDate
				}
				driverClockSummary {
					clockedInAt
					clockedOutAt
					workedMinutes
					returnedToWarehouseAt
					reminderDueAt
					reminderResolvedAt
					isClockedIn
					latestClockedInAt
					totalWorkedMinutes
				}
				checklistSubmissions {
					id
					purpose
					status
					flaggedItemIds
					submittedAt
					approvedAt
					approvedBy {
						id
						firstname
						lastname
					}
					signOffManager {
						id
						firstname
						lastname
					}
					signOffNote
				}
				route {
					id
					name
				}
				driver {
					id
					username
					firstname
					lastname
				}
				vehicle {
					id
					name
				}
				serviceDockets {
					id
					status
					date
					markedCompleteAt
					order
					manualRestock
					startedProcessing
					inventoryCheck
					hasSomeExpiryDatesToUpdate
					productExpiryCheckSchedules {
						id
					}
					isIngredientRestock
					inventoryPicked
					inventoryPartiallyPicked
					pickListGenerationStatus
					isRestocked
					ticketsResolved
					machineRestockType
					cashBag
					collectCash
					cashCollected
					requirePhoto
					photoTaken
					machineServiceType
					packTags {
						id
						labelPrintOnly
					}
					driverTicketCount
					totalPickItemsQuantity
					...stopCouldNotComplete
					pickList {
						id
						isAnyItemPicked
						hasProductSoldSinceLastPickListRecalculation
						calculatedAt
					}
					ticketList {
						id
						driverItems {
							id
							notResolved
							ticket {
								id
								status
							}
						}
					}
					machine {
						id
						type
						assetId
						isOffline
						hasCoinMech
						usesIngredients
						machineKey {
							id
							name
						}
						noteReader {
							id
						}
						commDevices {
							id
						}
						place {
							id
							name
							requiresAccessPass
							accessPassDetails
							requiredEquipment
						}
						location {
							id
							name
							requiresAccessPass
							requiresSignIn
							signInInstructions
							accessPassDetails
							requiredEquipment
						}
					}
				}
			}
			count
		}
	}
	${COULD_NOT_COMPLETE_FRAGMENT}
`;

export default GET_SERVICE_RUNS_MY_DAY_PREVIEW;
